import React from 'react'
import MachineDetails from '../features/machineDetails/MachineDetails';
function MachineDetailsPage() {
  return (
    <MachineDetails />
  )
}

export default MachineDetailsPage